import AOS from "aos";
import get from "lodash/get";

export const useProjectMethods = () => {
  const preloaderDone = () => {
    const runtimeConfig = useRuntimeConfig();

    const preloaderEl = document.querySelector(".preloader");
    if (preloaderEl?.classList.contains("is-none")) return;

    const delay = runtimeConfig.public.preloaderDelay || 500;

    setTimeout(() => {
      preloaderEl?.classList.add("loaded");
    }, delay);

    setTimeout(() => {
      preloaderEl?.classList.add("is-none");
    }, delay + 500);
  };

  const getContent = (contentData, defaultLocaleContentData, path) =>
    get(contentData, path) ?? get(defaultLocaleContentData, path);

  const getLocalesContentData = (
    currentLocaleContentResponse,
    defaultLocaleContentResponse
  ) => {
    // I NEED PROXY IN RETURN
    const contentData = reactive({
      currentLocaleData: undefined,
      defaultLocaleData: undefined,
    });

    if (currentLocaleContentResponse.status !== "rejected") {
      contentData.currentLocaleData = currentLocaleContentResponse.value;
    }

    if (defaultLocaleContentResponse.status !== "rejected") {
      contentData.defaultLocaleData = defaultLocaleContentResponse.value;
    }

    return contentData;
  };

  const localizePath = (path) => {
    const globalStore = useGlobalStore();
    if (
      globalStore.currentLocale?.code.toLowerCase() ===
      globalStore.defaultLocale?.code.toLowerCase()
    ) {
      if (!path) return "";
      return path.startsWith("/") ? path : `/${path}`;
    }
    return `/${globalStore.currentLocale?.code.toLowerCase()}${
      !path || path === "/" ? "" : path
    }`;
  };

  const replaceContent = (content, separator) => {
    if (!content) return "";

    const pathArr = content.split(separator);
    let newString = "";
    pathArr.forEach((path, index) => {
      if (index % 2) {
        newString += `<span class="highlighted-text">${path}</span>`;
      } else {
        newString += `${path}`;
      }
    });
    return newString;
  };

  const createSrcSet = (src) => {
    if (!src) return "";

    const webpSrc = src.replace(/\.\w+$/, ".webp");
    return `${webpSrc}, ${src}`;
  };

  const initAOS = () => {
    const runtimeConfig = useRuntimeConfig();
    const delay = runtimeConfig.public.preloaderDelay || 500;

    setTimeout(() => {
      AOS.init({
        duration: 1000,
        easing: "ease",
        offset: 0,
        once: true,
        mirror: false,
        anchorPlacement: "center-bottom",
      });
    }, delay);
  };

  return {
    preloaderDone,
    getContent,
    getLocalesContentData,
    localizePath,
    replaceContent,
    createSrcSet,
    initAOS,
  };
};
